import { SxProps, Theme } from '@mui/material';
import { atlasSemantic } from 'src/theme/atlas/tokens';

export const container: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  backgroundColor: atlasSemantic.color.surface.variant,
  borderRadius: atlasSemantic.radius.lg,
  padding: '24px',
};

export const title: SxProps<Theme> = {
  fontSize: '20px',
  fontWeight: 600,
  color: atlasSemantic.color.type.default,
  marginBottom: '16px',
};

export const grid: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
  gap: '16px',
};

export const field: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const readOnlyValue: SxProps<Theme> = {
  pointerEvents: 'none',
  '& .MuiSelect-select': {
    backgroundColor: atlasSemantic.color.background.container,
  },
};

export const sectionGroup: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const sectionHeader: SxProps<Theme> = {
  fontSize: '15px',
  fontWeight: 700,
  color: atlasSemantic.color.type.default,
};

export const sectionCard: SxProps<Theme> = {
  backgroundColor: atlasSemantic.color.surface.default,
  borderRadius: atlasSemantic.radius.lg,
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
};
